import React, { useState, useRef, useEffect } from 'react';
import '../../Assets/Css/ViewAward.scss';
import Swal from 'sweetalert2';
import { useLocation, useNavigate } from 'react-router-dom';
import { getIconComponent } from '../../Lib/utils';

const ViewAward = (props) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();
    const data = location?.state?.data?.allData;
    const Icon = getIconComponent(data?.icon);
    const handleDropdownToggle = () => {
        setShowDropdown(prevState => !prevState);
    };

    const handleEdit = () => {
        navigate('/employees/view/award/add');
    };

    const handleDelete = async () => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You will not be able to recover the deleted record!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#5757FE",
            cancelButtonColor: "transparent",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel",
            customClass: {
                cancelButton: 'custom-cancel-button',
            },
        });

        if (result.isConfirmed) {
            Swal.fire({
                title: "Deleted!",
                text: "Your record has been deleted.",
                icon: "success"
            });
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
            <div className="viewAward-main">
                <div className="page-title">
                    <div className="d-flex justify-content-between align-items-center">
                        <h4>{data?.title}</h4>
                    </div>
                    <div className="edit-btn">
                        <button
                            type="submit"
                            className="custom-btn"
                            onClick={() => navigate(-1)}
                        >Cancel</button>
                    </div>
                </div>
                <div className="content-part">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="left-part">
                                <div className="custom-row">
                                    <div className="award-detail">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <h5 className='award-detail-divider'>Award Details</h5>

                                        </div>
                                        <div className="row">
                                            <div className="input-groups">
                                                <div className="col-3">
                                                    <h6 className='labels'>Title</h6>
                                                </div>
                                                <div className="col-9">
                                                    <h6 className='labels'>{data?.title}</h6>
                                                </div>
                                            </div>

                                            <div className="input-groups">
                                                <div className="col-3">
                                                    <h6 className='labels'>Icon</h6>
                                                </div>
                                                <div className="col-9"
                                                    style={{
                                                        backgroundColor: data?.icon_background_color || '#eee',
                                                        width: 40,
                                                        height: 40,
                                                        borderRadius: '50%',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        color: '#fff',
                                                        fontSize: 20,
                                                    }}>
                                                    <Icon />
                                                </div>
                                            </div>

                                            <div className="input-groups">
                                                <div className="col-3">
                                                    <h6 className='labels'>Color</h6>
                                                </div>
                                                <div className="col-9">
                                                    <h6 className='labels'>{data?.icon_background_color}</h6>
                                                </div>
                                            </div>

                                            <div className="input-groups">
                                                <div className="col-3">
                                                    <h6 className='labels'>Summary</h6>
                                                </div>
                                                <div className="col-9">
                                                    <h6 className='labels' dangerouslySetInnerHTML={{ __html: data?.summary }}></h6>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    )
}

export default ViewAward;